module.exports = __webpack_public_path__ + "6e1642c44cc5a708ebaf31f4b69dc0c3.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1150
// module chunks = 0